// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__2r0ZT","Appear":"Backdrop__Appear__XfRlq","appear":"Backdrop__appear__2I_Jx","btn":"Backdrop__btn__29j6D","pulse":"Backdrop__pulse__2bMBL","NewGame":"Backdrop__NewGame__sZSrd","Continue":"Backdrop__Continue__3-FRg"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Backdrop/Backdrop.css
// module id = 120
// module chunks = 0